// extracted by mini-css-extract-plugin
export default {"profile":"styles_profile__oLDx6","profile__avatar":"styles_profile__avatar__AOKi+"};